import { RAMQCaracteristiqueSante } from "./RAMQCaracteristiqueSante";

class RAMQPathology {
    public PathoList: RAMQCaracteristiqueSante[];
    public ErrorMessages: string[];
}

export { RAMQPathology };
